import { render, staticRenderFns } from "./OrderStatisticsList.vue?vue&type=template&id=3bbe243a&scoped=true"
import script from "./OrderStatisticsList.vue?vue&type=script&lang=js"
export * from "./OrderStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./OrderStatisticsList.vue?vue&type=style&index=0&id=3bbe243a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe243a",
  null
  
)

export default component.exports